(function () {
  'use strict';
  if (window.mcMenuRuntime) { window.mcMenuRuntime.mount(document); return; }
  const instances = new Map();
  function createCartAdapter() {
    const subscribers = new Set();
    const nativeFetch = window.fetch.bind(window);
    let state = null;
    let generation = 0;
    let pending = null;
    let timer = null;
    function publish(cart) {
      state = cart;
      for (const subscriber of subscribers) subscriber(cart);
    }
    async function refresh() {
      const version = ++generation;
      pending?.abort();
      pending = new AbortController();
      try {
        const response = await nativeFetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
          credentials: 'same-origin', signal: pending.signal
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (version === generation) publish(cart);
      } catch { /* Retain the last confirmed cart when a request fails. */ }
    }
    function queue() {
      generation += 1;
      pending?.abort();
      window.clearTimeout(timer);
      timer = window.setTimeout(refresh, 60);
    }
    function isCartMutation(input) {
      try {
        const url = new URL(typeof input === 'string' ? input : input.url || String(input), location.origin);
        return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
      } catch { return false; }
    }
    window.fetch = function (...args) {
      const mutation = isCartMutation(args[0]);
      if (mutation) { generation += 1; pending?.abort(); }
      return nativeFetch(...args).then((response) => { if (mutation) queue(); return response; });
    };
    const nativeOpen = XMLHttpRequest.prototype.open;
    const nativeSend = XMLHttpRequest.prototype.send;
    const requests = new WeakMap();
    XMLHttpRequest.prototype.open = function (method, url) {
      requests.set(this, isCartMutation(url));
      return nativeOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (requests.get(this)) {
        generation += 1; pending?.abort();
        this.addEventListener('loadend', queue, { once: true });
      }
      return nativeSend.apply(this, arguments);
    };
    for (const eventName of ['cart:update', 'cart:updated', 'cart:change', 'theme:cart:change']) {
      document.addEventListener(eventName, (event) => {
        const detail = event.detail || {};
        const cart = detail.cart || detail.data || detail;
        generation += 1; pending?.abort(); window.clearTimeout(timer);
        if (typeof cart.total_price === 'number' && typeof cart.item_count === 'number') publish(cart);
        else queue();
      });
    }
    document.addEventListener('visibilitychange', () => { if (!document.hidden && subscribers.size) queue(); });
    return {
      subscribe(callback) {
        subscribers.add(callback);
        if (state) callback(state);
        queue();
        return () => subscribers.delete(callback);
      }
    };
  }
  const cartAdapter = createCartAdapter();
  function initialize(wrapper) {
  if (instances.has(wrapper)) return;
  const lifecycle = new AbortController();
  const cleanups = [];
  let disposed = false;
  const timers = new Set();
  const intervals = new Set();
  const frames = new Set();
  const setTimeout = (callback, delay) => {
    const id = window.setTimeout(() => { timers.delete(id); if (!disposed) callback(); }, delay);
    timers.add(id); return id;
  };
  const clearTimeout = (id) => { window.clearTimeout(id); timers.delete(id); };
  const setInterval = (callback, delay) => {
    const id = window.setInterval(() => { if (!disposed) callback(); }, delay);
    intervals.add(id); return id;
  };
  const clearInterval = (id) => { window.clearInterval(id); intervals.delete(id); };
  const requestAnimationFrame = (callback) => {
    const id = window.requestAnimationFrame(() => { frames.delete(id); if (!disposed) callback(); });
    frames.add(id); return id;
  };
  const listen = (target, type, callback, options = {}) => {
    target.addEventListener(type, callback, { ...(typeof options === 'boolean' ? { capture: options } : options), signal: lifecycle.signal });
  };
  function dispose() {
    if (disposed) return;
    closeDrawer(); closeSearch();
    disposed = true;
    searchAbortController?.abort();
    lifecycle.abort();
    timers.forEach(window.clearTimeout); intervals.forEach(window.clearInterval); frames.forEach(window.cancelAnimationFrame);
    cleanups.forEach((cleanup) => cleanup());
    instances.delete(wrapper);
  }
  instances.set(wrapper, dispose);
  

  
  // Performance: Cache DOM queries
  const $ = (sel, ctx) => (ctx || wrapper).querySelector(sel);
  const $$ = (sel, ctx) => (ctx || wrapper).querySelectorAll(sel);
  
  // Elements
  const toggle = $('[data-mc-toggle]');
  const drawer = $('[data-mc-drawer]');
  const overlay = $('[data-mc-overlay]');
  const closeBtn = $('[data-mc-close]');
  const searchBtn = $('[data-mc-search]');
  const cartBtn = $('[data-mc-cart]');
  const searchOverlay = $('[data-mc-search-overlay]');
  const searchBackdrop = $('[data-mc-search-backdrop]');
  const searchInput = $('[data-mc-search-input]');
  const searchClear = $('[data-mc-search-clear]');
  const searchClose = $('[data-mc-search-close]');
  const menuItems = $$('[data-mc-item]');
  const submenuBtns = $$('[data-mc-submenu]');
  
  const stickyType = wrapper.dataset.sticky;
  const searchBehavior = wrapper.dataset.search;
  let drawerPreviousFocus = null;
  let searchPreviousFocus = null;
  let restoringSearchFocus = false;
  let bodyStyles = null;
  function lockBody() {
    if (bodyStyles) return;
    bodyStyles = { overflow: document.body.style.overflow, paddingRight: document.body.style.paddingRight };
    const width = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (width > 0) document.body.style.paddingRight = width + 'px';
  }
  function unlockBody() {
    if (!bodyStyles) return;
    Object.assign(document.body.style, bodyStyles);
    bodyStyles = null;
  }
  function visibleFocusable(container) {
    return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter((element) => element.tabIndex >= 0 && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  }
  function trapFocus(event, container) {
    const items = visibleFocusable(container);
    const first = items[0], last = items[items.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (!container.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }
  
  // Utility: Debounce function for performance
  const debounce = (fn, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  };
  
  // Utility: Throttle for scroll events
  const throttle = (fn, limit) => {
    let waiting = false;
    return (...args) => {
      if (!waiting) {
        fn.apply(this, args);
        waiting = true;
        setTimeout(() => waiting = false, limit);
      }
    };
  };
  
  // ===== Mobile Menu =====
  function openDrawer() {
    closeSearch();
    drawerPreviousFocus = document.activeElement;
    toggle && toggle.setAttribute('aria-expanded', 'true');
    drawer && drawer.classList.add('is-open');
    drawer && drawer.setAttribute('aria-hidden', 'false');
    if (drawer) drawer.inert = false;
    overlay && overlay.classList.add('is-open');
    lockBody();
    requestAnimationFrame(function() {
      closeBtn && closeBtn.focus();
    });
  }
  
  function closeDrawer() {
    const wasOpen = drawer && drawer.classList.contains('is-open');
    toggle && toggle.setAttribute('aria-expanded', 'false');
    drawer && drawer.classList.remove('is-open');
    drawer && drawer.setAttribute('aria-hidden', 'true');
    if (drawer) drawer.inert = true;
    overlay && overlay.classList.remove('is-open');
    if (wasOpen) unlockBody();
    if (wasOpen) {
      const focusTarget = drawerPreviousFocus && document.contains(drawerPreviousFocus)
        ? drawerPreviousFocus
        : toggle;
      focusTarget && focusTarget.focus();
      drawerPreviousFocus = null;
    }
  }
  
  toggle && listen(toggle, 'click', function(e) {
    e.preventDefault();
    this.getAttribute('aria-expanded') === 'true' ? closeDrawer() : openDrawer();
  });
  
  closeBtn && listen(closeBtn, 'click', function(e) { e.preventDefault(); closeDrawer(); });
  overlay && listen(overlay, 'click', closeDrawer);
  
  // Mobile swipe to close drawer
  if (drawer) {
    let touchStartX = 0;
    let touchEndX = 0;
    const drawerPosition = wrapper.dataset.drawerPosition;
    
    listen(drawer, 'touchstart', function(e) {
      // Don't capture touch events on sliders
      if (e.target.closest('[data-mc-slider]')) return;
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    listen(drawer, 'touchend', function(e) {
      if (e.target.closest('[data-mc-slider]')) return;
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchEndX - touchStartX;
      
      // Swipe left closes left drawer, swipe right closes right drawer
      if (drawerPosition === 'left' && diff < -50) closeDrawer();
      if (drawerPosition === 'right' && diff > 50) closeDrawer();
    }, { passive: true });
  }
  
  // Mobile drawer sliders - Enhanced touch scrolling
  const mobileSliders = $$('[data-mc-slider]');
  mobileSliders.forEach(function(slider) {
    let isDown = false;
    let startX;
    let scrollLeft;
    
    listen(slider, 'mousedown', function(e) {
      isDown = true;
      slider.classList.add('is-grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    
    listen(slider, 'mouseleave', function() {
      isDown = false;
      slider.classList.remove('is-grabbing');
    });
    
    listen(slider, 'mouseup', function() {
      isDown = false;
      slider.classList.remove('is-grabbing');
    });
    
    listen(slider, 'mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
    
    // Prevent click events when dragging
    let isDragging = false;
    listen(slider, 'touchstart', function() {
      isDragging = false;
    }, { passive: true });
    
    listen(slider, 'touchmove', function() {
      isDragging = true;
    }, { passive: true });
    
    slider.querySelectorAll('a').forEach(function(link) {
      listen(link, 'click', function(e) {
        if (isDragging) {
          e.preventDefault();
        }
      });
    });
  });
  
  // Mobile submenus - toggle function
  function toggleDrawerSubmenu(item) {
    if (!item) return;

    const isOpen = item.classList.contains('is-open');
    const parentList = item.parentElement;
    const toggleBtn = item.querySelector('[data-mc-submenu]');

    // Close siblings at same level
    parentList.querySelectorAll(':scope > .is-open').forEach(function(s) {
      if (s !== item) {
        s.classList.remove('is-open');
        const b = s.querySelector('[data-mc-submenu]');
        b && b.setAttribute('aria-expanded', 'false');
      }
    });

    item.classList.toggle('is-open', !isOpen);
    toggleBtn && toggleBtn.setAttribute('aria-expanded', String(!isOpen));
  }

  // Click on toggle buttons
  submenuBtns.forEach(function(btn) {
    listen(btn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const item = this.closest('.mc-menu-drawer-item, .mc-menu-drawer-subitem');
      toggleDrawerSubmenu(item);
    });
  });

  $$('[data-mc-mega-carousel]').forEach(function(carousel) {
    const track = carousel.querySelector('[data-mc-mega-track]');
    const previous = carousel.querySelector('[data-mc-mega-prev]');
    const next = carousel.querySelector('[data-mc-mega-next]');
    if (!track || !previous || !next) return;

    function updateCarouselControls() {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
    }

    function moveCarousel(direction) {
      track.scrollBy({ left: direction * Math.max(180, track.clientWidth * 0.72), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      setTimeout(updateCarouselControls, 500);
    }

    listen(previous, 'click', function() { moveCarousel(-1); });
    listen(next, 'click', function() { moveCarousel(1); });
    listen(track, 'scroll', throttle(updateCarouselControls, 80), { passive: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(updateCarouselControls);
      observer.observe(track);
      cleanups.push(() => observer.disconnect());
    }
    updateCarouselControls();
  });

  // Mobile drawer search button
  const drawerSearchBtn = $('[data-mc-drawer-search]');
  if (drawerSearchBtn) {
    listen(drawerSearchBtn, 'click', function() {
      closeDrawer();
      setTimeout(function() {
        openSearch();
      }, 300);
    });
  }
  
  // ===== Desktop Dropdowns =====
  let hoverOpenTimer = null;
  let hoverCloseTimer = null;
  const hoverCloseDelay = 250; // Delay before closing dropdown (ms) - increased for better UX

  menuItems.forEach(function(item) {
    if (!item.classList.contains('has-dropdown')) return;
    const link = item.querySelector('.mc-menu-link');
    const dropdown = item.querySelector('.mc-menu-dropdown');

    function openDropdown() {
      clearTimeout(hoverCloseTimer);
      clearTimeout(hoverOpenTimer);
      hoverOpenTimer = setTimeout(function() {
        menuItems.forEach(function(i) {
          if (i !== item && i.classList.contains('is-open')) {
            i.classList.remove('is-open');
            const l = i.querySelector('.mc-menu-link');
            l && l.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.add('is-open');
        link && link.setAttribute('aria-expanded', 'true');
      }, Number(wrapper.dataset.hoverDelay || 150));
    }

    function closeDropdown() {
      clearTimeout(hoverOpenTimer);
      clearTimeout(hoverCloseTimer);
      hoverCloseTimer = setTimeout(function() {
        if (item.contains(document.activeElement)) return;
        item.classList.remove('is-open');
        link && link.setAttribute('aria-expanded', 'false');
      }, hoverCloseDelay);
    }

    listen(item, 'focusout', () => {
      requestAnimationFrame(() => {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-open');
          link?.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Mouse enters the menu item (link area)
    listen(item, 'mouseenter', openDropdown);

    // Mouse leaves the menu item
    listen(item, 'mouseleave', closeDropdown);

    // If dropdown exists, keep it open when hovering over it
    if (dropdown) {
      listen(dropdown, 'mouseenter', function() {
        clearTimeout(hoverCloseTimer);
        clearTimeout(hoverOpenTimer);
      });

      listen(dropdown, 'mouseleave', closeDropdown);
    }
  });
  
  listen(document, 'click', function(e) {
    if (!wrapper.contains(e.target)) {
      menuItems.forEach(function(item) {
        item.classList.remove('is-open');
        const link = item.querySelector('.mc-menu-link');
        link && link.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ===== Mega Dropdown Positioning =====
  // Dynamically calculate and set mega dropdown top position
  function updateMegaDropdownPosition() {
    const wrapperRect = wrapper.getBoundingClientRect();
    const megaTop = wrapperRect.bottom;
    wrapper.style.setProperty('--mc-mega-top', megaTop + 'px');
  }

  // Update position on scroll and resize
  let megaPositionTicking = false;
  function requestMegaPositionUpdate() {
    if (!megaPositionTicking) {
      requestAnimationFrame(function() {
        updateMegaDropdownPosition();
        megaPositionTicking = false;
      });
      megaPositionTicking = true;
    }
  }

  // Initial position update
  updateMegaDropdownPosition();

  // Update on scroll (needed when header is sticky)
  listen(window, 'scroll', requestMegaPositionUpdate, { passive: true });
  listen(window, 'resize', requestMegaPositionUpdate, { passive: true });

  // Also update when dropdown is about to open
  menuItems.forEach(function(item) {
    if (item.classList.contains('has-dropdown')) {
      listen(item, 'mouseenter', updateMegaDropdownPosition);
    }
  });

  // ===== Sticky Header =====
  const placeholder = wrapper.parentElement.querySelector('[data-mc-placeholder]');
  
  if (stickyType === 'scroll-up') {
    let lastY = window.scrollY;
    let ticking = false;
    let headerHeight = wrapper.offsetHeight;
    let headerTop = wrapper.getBoundingClientRect().top + window.scrollY;
    let isPinned = false;
    
    // Update measurements on resize
    function updateMeasurements() {
      if (!isPinned) {
        headerHeight = wrapper.offsetHeight;
        headerTop = wrapper.getBoundingClientRect().top + window.scrollY;
      }
      if (placeholder) {
        placeholder.style.height = headerHeight + 'px';
      }
    }
    
    // Initial setup
    updateMeasurements();
    listen(window, 'resize', debounce(updateMeasurements, 200));
    
    listen(window, 'scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          const currentY = window.scrollY;
          const diff = currentY - lastY;
          
          // Determine if we should pin (scrolled past header)
          const shouldPin = currentY > headerTop + headerHeight;
          
          if (shouldPin && !isPinned) {
            // Pin the header
            isPinned = true;
            wrapper.classList.add('is-pinned');
            placeholder && placeholder.classList.add('is-active');
          } else if (!shouldPin && isPinned) {
            // Unpin the header
            isPinned = false;
            wrapper.classList.remove('is-pinned', 'is-hidden');
            placeholder && placeholder.classList.remove('is-active');
          }
          
          // Add shadow when scrolled
          if (currentY > 10) {
            wrapper.classList.add('is-scrolled');
          } else {
            wrapper.classList.remove('is-scrolled');
          }
          
          // Show/hide based on scroll direction (only when pinned)
          if (isPinned) {
            if (diff > 10) {
              // Scrolling down - hide
              wrapper.classList.add('is-hidden');
            } else if (diff < -10) {
              // Scrolling up - show
              wrapper.classList.remove('is-hidden');
            }
          }
          
          lastY = currentY;
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  } else if (stickyType === 'always') {
    let lastScrolled = false;
    listen(window, 'scroll', function() {
      const isScrolled = window.scrollY > 10;
      // Only update DOM if state changed (avoid layout thrashing)
      if (isScrolled !== lastScrolled) {
        lastScrolled = isScrolled;
        wrapper.classList.toggle('is-scrolled', isScrolled);
      }
    }, { passive: true });
  }
  
  // ===== Premium Search Experience =====
  const searchInitial = $('[data-mc-search-initial]');
  const searchLoading = $('[data-mc-search-loading]');
  const searchEmpty = $('[data-mc-search-empty]');
  const searchResults = $('[data-mc-search-results]');
  const recentSearches = $('[data-mc-recent-searches]');
  const recentList = $('[data-mc-recent-list]');
  const clearRecentBtn = $('[data-mc-clear-recent]');
  const viewAllProducts = $('[data-mc-view-all-products]');
  
  // Recent searches storage
  const RECENT_KEY = 'mc_recent_searches';
  const MAX_RECENT = 5;
  
  function getRecentSearches() {
    try {
      return JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch(e) { return []; }
  }
  
  function saveRecentSearch(term) {
    if (!term || term.length < 2) return;
    let recent = getRecentSearches();
    recent = recent.filter(r => r.toLowerCase() !== term.toLowerCase());
    recent.unshift(term);
    recent = recent.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recent)); } catch(e) {}
    renderRecentSearches();
  }
  
  function clearRecentSearches() {
    try { localStorage.removeItem(RECENT_KEY); } catch(e) {}
    renderRecentSearches();
  }
  
  function renderRecentSearches() {
    const recent = getRecentSearches();
    if (!recentList || !recentSearches) return;
    
    if (recent.length === 0) {
      recentSearches.hidden = true;
      return;
    }
    
    recentSearches.hidden = false;
    recentList.innerHTML = recent.map(term => 
      '<li class="mc-menu-search-recent-item" data-mc-recent-term="' + term.replace(/"/g, '&quot;') + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' +
      '<span>' + escapeHtml(term) + '</span></li>'
    ).join('');
  }

  // Search state variables (must be declared before openSearch/closeSearch)
  let searchTimer = null;
  let searchAbortController = null;
  let currentSearchQuery = '';
  let activeResultIndex = -1;
  const searchResultsCount = parseInt(wrapper.dataset.searchResultsCount) || 8;
  const showVendor = wrapper.dataset.showVendor === 'true';
  const skuLabel = wrapper.dataset.skuLabel || 'SKU';
  const productSkuCache = new Map();

  function openSearch() {
    if (!searchOverlay || searchOverlay.classList.contains('is-open')) return;
    searchPreviousFocus = document.activeElement;
    closeDrawer();
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    searchOverlay.inert = false;
    lockBody();
    renderRecentSearches();
    showSearchState('initial');
    setTimeout(() => { if (searchOverlay.classList.contains('is-open')) searchInput?.focus(); }, 150);
  }
  
  function closeSearch() {
    if (!searchOverlay || !searchOverlay.classList.contains('is-open')) return;
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
    searchOverlay.inert = true;
    unlockBody();
    const focusTarget = [searchPreviousFocus, searchBtn, toggle].find((element) => element?.isConnected && !element.closest('[hidden], [inert], [aria-hidden="true"]') && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
    restoringSearchFocus = true;
    focusTarget?.focus();
    restoringSearchFocus = false;
    searchPreviousFocus = null;
    searchInput && (searchInput.value = '');
    searchClear && (searchClear.hidden = true);
    currentSearchQuery = '';
    activeResultIndex = -1;
    // Abort any in-flight search
    if (searchAbortController) { searchAbortController.abort(); searchAbortController = null; }
    clearTimeout(searchTimer);
    showSearchState('initial');
  }
  
  function showSearchState(state) {
    searchOverlay && searchOverlay.setAttribute('data-search-state', state);
    searchInitial && (searchInitial.style.display = state === 'initial' ? 'block' : 'none');
    searchLoading && searchLoading.classList.toggle('is-visible', state === 'loading');
    searchEmpty && searchEmpty.classList.toggle('is-visible', state === 'empty');
    searchResults && searchResults.classList.toggle('is-visible', state === 'results');
  }
  
  // Event listeners
  searchBtn && listen(searchBtn, 'click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Check if this is part of an expandable search container
    const expandableContainer = this.closest('[data-mc-expandable-search]');
    if (expandableContainer) {
      expandableContainer.classList.add('is-expanded');
      const input = expandableContainer.querySelector('input[type="search"]');
      input && input.focus();
      return;
    }
    
    if (searchBehavior === 'live' && searchOverlay) {
      openSearch();
    } else if (searchBehavior === 'theme') {
      document.dispatchEvent(new CustomEvent('dispatch:search:open'));
    } else {
      window.location.href = '/search';
    }
  });
  
  // Handle expandable search close
  const expandableSearch = $('[data-mc-expandable-search]');
  if (expandableSearch) {
    const closeInlineSearch = () => {
      expandableSearch.classList.remove('is-expanded');
      // Re-show the search icon button
      const searchIcon = expandableSearch.querySelector('.mc-menu-action[data-mc-search]');
      if (searchIcon) {
        searchIcon.style.display = '';
        searchIcon.style.opacity = '';
      }
    };

    // Close button click
    const inlineCloseBtn = expandableSearch.querySelector('[data-mc-search-inline-close]');
    inlineCloseBtn && listen(inlineCloseBtn, 'click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeInlineSearch();
    });

    // Close on outside click
    listen(document, 'click', function(e) {
      if (!expandableSearch.contains(e.target) && expandableSearch.classList.contains('is-expanded')) {
        closeInlineSearch();
      }
    });
    
    // Close on escape
    listen(document, 'keydown', function(e) {
      if (e.key === 'Escape' && expandableSearch.classList.contains('is-expanded')) {
        closeInlineSearch();
      }
    });
  }
  
  // Handle inline search form submission
  const inlineSearch = $('[data-mc-inline-search]');
  if (inlineSearch) {
    const inlineInput = inlineSearch.querySelector('input[type="search"]');
    
    // Open live search overlay when typing in inline search (if live search is enabled)
    if (inlineInput && searchBehavior === 'live' && searchOverlay) {
      listen(inlineInput, 'focus', function() {
        if (restoringSearchFocus) return;
        openSearch();
        // Transfer value to overlay input
        if (searchInput && this.value) {
          searchInput.value = this.value;
          searchInput.dispatchEvent(new Event('input'));
        }
      });
    }
  }
  
  const searchCloseBtn = $('[data-mc-search-close]');
  searchCloseBtn && listen(searchCloseBtn, 'click', e => { e.preventDefault(); closeSearch(); });
  searchBackdrop && listen(searchBackdrop, 'click', closeSearch);
  searchOverlay && listen(searchOverlay, 'click', function(e) {
    if (!e.target.closest('.mc-menu-search-container')) closeSearch();
  });
  
  searchClear && listen(searchClear, 'click', function(e) {
    e.preventDefault();
    searchInput && (searchInput.value = '');
    searchInput && searchInput.focus();
    searchClear.hidden = true;
    currentSearchQuery = '';
    activeResultIndex = -1;
    if (searchAbortController) { searchAbortController.abort(); searchAbortController = null; }
    clearTimeout(searchTimer);
    showSearchState('initial');
  });
  
  clearRecentBtn && listen(clearRecentBtn, 'click', clearRecentSearches);
  
  // Click on recent search term
  recentList && listen(recentList, 'click', function(e) {
    const item = e.target.closest('[data-mc-recent-term]');
    if (item) {
      const term = item.dataset.mcRecentTerm;
      searchInput && (searchInput.value = term);
      searchClear && (searchClear.hidden = false);
      doSearch(term);
    }
  });
  
  searchInput && listen(searchInput, 'input', function(e) {
    const q = e.target.value.trim();
    currentSearchQuery = q;
    if (searchAbortController) { searchAbortController.abort(); searchAbortController = null; }
    searchClear && (searchClear.hidden = !q);
    clearTimeout(searchTimer);
    activeResultIndex = -1;

    if (!q) {
      currentSearchQuery = '';
      if (searchAbortController) { searchAbortController.abort(); searchAbortController = null; }
      showSearchState('initial');
      return;
    }

    if (q.length < 2) {
      showSearchState('initial');
      return;
    }

    showSearchState('loading');
    searchTimer = setTimeout(() => doSearch(q), 250);
  });

  // Keyboard navigation in search results
  searchInput && listen(searchInput, 'keydown', function(e) {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      closeSearch();
      return;
    }

    const resultLinks = searchResults ? searchResults.querySelectorAll('a') : [];
    if (!resultLinks.length) return;

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      activeResultIndex = Math.min(activeResultIndex + 1, resultLinks.length - 1);
      resultLinks[activeResultIndex].focus();
      resultLinks[activeResultIndex].classList.add('is-focused');
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (activeResultIndex <= 0) {
        activeResultIndex = -1;
        searchInput.focus();
      } else {
        activeResultIndex--;
        resultLinks[activeResultIndex].focus();
        resultLinks[activeResultIndex].classList.add('is-focused');
      }
    }
  });

  // Submit search form - save to recent
  searchInput && searchInput.form && listen(searchInput.form, 'submit', function() {
    const q = searchInput.value.trim();
    if (q.length >= 2) saveRecentSearch(q);
  });

  function escapeHtml(str) {
    if (!str) return '';
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function highlightMatch(text, query) {
    if (!text || !query) return escapeHtml(text);
    const escaped = escapeHtml(text);
    const queryWords = query.toLowerCase().split(/\s+/).filter(w => w.length > 1);
    let result = escaped;
    queryWords.forEach(word => {
      const regex = new RegExp('(' + word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      result = result.replace(regex, '<mark>$1</mark>');
    });
    return result;
  }

  function formatMoney(cents) {
    if (cents == null) return '';
    // Use Shopify's money formatter if available
    if (window.Shopify && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    }
    // Fallback: format based on store currency
    const moneyFormat = wrapper.dataset.moneyFormat || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount)
                      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100))
                      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
                      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }

  function getSizedImageUrl(src, size) {
    if (!src) return '';
    if (typeof src === 'object') src = src.url || src.src || '';
    if (!src || typeof src !== 'string') return '';
    if (src.includes('cdn.shopify.com')) {
      return src.replace(/(_\d+x\d*(_crop_\w+)?)?(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + '$3$5');
    }
    return src;
  }

  function looksLikeSku(query) {
    if (!query) return false;
    const q = query.trim();
    // Match patterns: alphanumeric with dashes/dots, at least one digit, 3+ chars
    // Examples: ABC-123, 12345, SKU-001, A1B2C3, 10.5-BLK
    return /^[A-Za-z0-9._\- ]{3,}$/.test(q) && /\d/.test(q);
  }

  function getProductSku(product, signal) {
    const productPath = (product.url || ('/products/' + product.handle)).split('?')[0];
    const variantId = product.url ? new URL(product.url, window.location.origin).searchParams.get('variant') : null;
    const cacheKey = (product.handle || productPath) + ':' + (variantId || 'default');
    if (productSkuCache.has(cacheKey)) return Promise.resolve(productSkuCache.get(cacheKey));

    return fetch(productPath + '.js', { signal })
      .then(response => response.ok ? response.json() : null)
      .then(productData => {
        const variants = productData?.variants || [];
        const matchingVariant = variantId ? variants.find(variant => String(variant.id) === variantId) : null;
        const skuVariant = variantId ? matchingVariant : variants.find(variant => variant.available && variant.sku) || variants.find(variant => variant.sku);
        const sku = skuVariant?.sku || '';
        productSkuCache.set(cacheKey, sku);
        return sku;
      })
      .catch(error => {
        if (error.name === 'AbortError') throw error;
        return '';
      });
  }

  function doSearch(q) {
    currentSearchQuery = q;
    activeResultIndex = -1;

    // Abort any in-flight request
    if (searchAbortController) {
      searchAbortController.abort();
    }
    searchAbortController = new AbortController();
    const signal = searchAbortController.signal;

    showSearchState('loading');

    // Primary search: Shopify Predictive Search API
    // Uses resources[options][fields] to include SKU in searchable fields
    const suggestUrl = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection' +
      '&resources[limit]=' + searchResultsCount +
      '&resources[options][unavailable_products]=hide' +
      '&resources[options][fields]=title,product_type,variants.sku,variants.title,vendor,tag,body';

    const isSkuLike = looksLikeSku(q);

    fetch(suggestUrl, { signal })
      .then(r => r.json())
      .then(suggestData => {
        // If query changed while we were fetching, discard results
        if (q !== currentSearchQuery) return;

        let products = suggestData.resources?.results?.products || [];
        const collections = suggestData.resources?.results?.collections || [];

        // If no product results and query looks like a SKU, try a second search
        // using Shopify's full search which indexes SKUs more thoroughly
        if (!products.length && isSkuLike) {
          const skuSearchUrl = '/search/suggest.json?q=' + encodeURIComponent(q) +
            '&resources[type]=product' +
            '&resources[limit]=' + searchResultsCount +
            '&resources[options][unavailable_products]=hide' +
            '&resources[options][fields]=variants.sku';

          return fetch(skuSearchUrl, { signal })
            .then(r => r.json())
            .then(skuData => {
              if (q !== currentSearchQuery) return;
              const skuProducts = skuData.resources?.results?.products || [];
              return renderAllResults(
                skuProducts.length ? skuProducts : products,
                collections, q, signal
              );
            });
        }

        return renderAllResults(products, collections, q, signal);
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        console.error('[MC Search] Error:', err);
        showSearchState('empty');
      });
  }

  async function renderAllResults(products, collections, q, signal) {
    const hasResults = products.length || collections.length;

    if (!hasResults) {
      showSearchState('empty');
      return;
    }

    // Render products
    const productsSection = $('[data-mc-products-section]');
    const productsList = $('[data-mc-products-list]');

    if (products.length && productsList && productsSection) {
      const visibleProducts = products.slice(0, Math.min(searchResultsCount, 4));
      const productSkus = await Promise.all(visibleProducts.map(product => getProductSku(product, signal)));
      if (q !== currentSearchQuery) return;

      productsList.innerHTML = visibleProducts.map((p, index) => {
        const img = p.image || p.featured_image;
        const imgUrl = getSizedImageUrl(img, '300x300');

        const price = Math.round(parseFloat(p.price) * 100);
        const rawCompare = p.compare_at_price_max || p.compare_at_price;
        const comparePrice = rawCompare ? Math.round(parseFloat(rawCompare) * 100) : null;
        const onSale = comparePrice && comparePrice > price;
        const vendor = p.vendor || '';
        const sku = productSkus[index] || '';

        return '<a href="' + escapeHtml(p.url) + '" class="mc-menu-search-product" role="option">' +
          '<div class="mc-menu-search-product-image">' +
          (imgUrl ? '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="300" height="300">' : '<div class="mc-menu-search-product-placeholder"></div>') +
          (onSale ? '<span class="mc-menu-search-product-badge">Sale</span>' : '') +
          '</div>' +
          '<div class="mc-menu-search-product-info">' +
          (showVendor && vendor ? '<p class="mc-menu-search-product-vendor">' + escapeHtml(vendor) + '</p>' : '') +
          '<h4 class="mc-menu-search-product-title">' + highlightMatch(p.title, q) + '</h4>' +
          (sku ? '<p class="mc-menu-search-product-sku"><span>' + escapeHtml(skuLabel) + '</span> ' + escapeHtml(sku) + '</p>' : '') +
          '<div class="mc-menu-search-product-price">' +
          (onSale ? '<span class="mc-menu-search-product-price-compare">' + formatMoney(comparePrice) + '</span>' : '') +
          '<span class="' + (onSale ? 'mc-menu-search-product-price-sale' : '') + '">' + formatMoney(price) + '</span>' +
          '</div>' +
          '</div>' +
          '</a>';
      }).join('');
      productsSection.hidden = false;

      // Update view all link
      if (viewAllProducts) {
        viewAllProducts.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    } else if (productsSection) {
      productsSection.hidden = true;
    }

    // Render collections
    const collectionsSection = $('[data-mc-collections-section]');
    const collectionsList = $('[data-mc-collections-list]');

    if (collections.length && collectionsList && collectionsSection) {
      collectionsList.innerHTML = collections.slice(0, 3).map(c => {
        return '<a href="' + escapeHtml(c.url) + '" class="mc-menu-search-collection mc-menu-search-collection--text-only" role="option">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>' +
          '<span>' + highlightMatch(c.title, q) + '</span>' +
          '</a>';
      }).join('');
      collectionsSection.hidden = false;
      searchResults.classList.add('has-collections');
    } else if (collectionsSection) {
      collectionsSection.hidden = true;
      searchResults.classList.remove('has-collections');
    }

    showSearchState('results');

    // Save to recent on click
    const resultLinks = searchResults.querySelectorAll('a');
    resultLinks.forEach(link => {
      listen(link, 'click', () => saveRecentSearch(q), { once: true });
    });
  }
  
  // ===== Cart Button =====
  // Opens Horizon theme's cart drawer
  // IMPORTANT: Horizon theme must have cart_type set to "drawer" in Theme Settings > Cart
  cartBtn && listen(cartBtn, 'click', function(e) {
    e.preventDefault();

    // Method 1: Horizon - cart-drawer-component (web component)
    const cartDrawerComponent = document.querySelector('cart-drawer-component');
    if (cartDrawerComponent) {
      // Use the component's own opener so scroll lock, focus and back-button handling run
      if (typeof cartDrawerComponent.open === 'function') {
        cartDrawerComponent.open();
        return;
      }
      const dialog = cartDrawerComponent.querySelector('dialog, .cart-drawer__dialog');
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        return;
      }
      if (dialog) {
        dialog.setAttribute('open', '');
        dialog.classList.add('is-open');
        return;
      }
    }

    // Method 2: Horizon - cart-drawer element with open property
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { itemCount: Number(cartCountElements[0]?.dataset.count || 0), source: 'product-form-component' } }
      }));
      cartDrawer.open = true;
      return;
    }

    // Method 3: Try clicking Horizon's cart-icon-bubble in the header (even if hidden)
    const cartIconBubble = document.querySelector('cart-icon-bubble');
    if (cartIconBubble) {
      const bubbleButton = cartIconBubble.querySelector('button') || cartIconBubble;
      bubbleButton.click();
      return;
    }

    // Method 3: Look for any element that controls the cart drawer
    const cartTriggers = document.querySelectorAll('[aria-controls*="cart"], [data-cart-trigger], .js-cart-trigger');
    for (const trigger of cartTriggers) {
      if (trigger !== e.currentTarget && !trigger.closest('[data-mc-menu]')) {
        trigger.click();
        return;
      }
    }

    // Method 4: Dispatch standard cart events
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { bubbles: true, detail: { opener: e.currentTarget } }));

    // Method 5: Check if drawer exists but isn't found by our queries
    // Look for common drawer patterns
    const possibleDrawers = document.querySelectorAll('[id*="cart"][id*="drawer"], [class*="cart"][class*="drawer"], aside[id*="cart"]');
    for (const drawer of possibleDrawers) {
      if (drawer.classList.contains('hidden') || drawer.hasAttribute('hidden')) {
        drawer.classList.remove('hidden');
        drawer.removeAttribute('hidden');
      }
      // Try to open it
      if ('open' in drawer) {
        drawer.open = true;
        return;
      }
      drawer.classList.add('is-open', 'active', 'open');
      drawer.setAttribute('open', '');
      return;
    }

    // Fallback: Go to cart page if no drawer exists
    // This happens when cart_type is set to "page" in theme settings
    window.location.href = '/cart';
  });
  
  // ===== Unified Cart Count + Free Shipping Sync =====
  const cartCountElements = $$('[data-mc-cart-count]');
  const shippingTextElements = $$('[data-mc-shipping-text]');


  function formatCartMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function applyCartState(cartState) {
    if (!cartState) return;

    const itemCount = typeof cartState.item_count === 'number' ? cartState.item_count : cartState.itemCount;
    if (typeof itemCount === 'number') {
      cartCountElements.forEach(function(el) {
        el.textContent = itemCount;
        el.dataset.count = itemCount;
        el.classList.toggle('is-empty', itemCount === 0);
      });
      document.querySelectorAll('.mc-menu-cart-count, [data-cart-count]').forEach(function(el) {
        el.textContent = itemCount;
        if (el.dataset) el.dataset.count = itemCount;
      });
    }

    if (typeof cartState.total_price !== 'number') return;
    shippingTextElements.forEach(function(el) {
      const threshold = parseFloat(el.dataset.threshold || wrapper.dataset.freeShipping || 0) * 100;
      if (threshold <= 0) return;

      const total = cartState.total_price;
      const emptyMsg = el.dataset.emptyMsg || 'Free shipping on orders $50+';
      const progressMsg = el.dataset.progressMsg || 'Add [amount] for free shipping';
      const qualifiedMsg = el.dataset.qualifiedMsg || 'You will receive free shipping';
      if (total <= 0) {
        el.textContent = emptyMsg;
      } else if (total < threshold) {
        el.textContent = progressMsg.replace('[amount]', formatCartMoney(threshold - total));
      } else {
        el.textContent = qualifiedMsg;
      }

      const fill = el.closest('[data-mc-shipping-message], .mc-menu-topbar-single')?.querySelector('.mc-menu-shipping-fill');
      if (fill) fill.style.width = Math.min(100, Math.max(0, total / threshold * 100)) + '%';
    });
  }

  if (cartCountElements.length || shippingTextElements.length) {
    cleanups.push(cartAdapter.subscribe(applyCartState));
  }

  // ===== Keyboard Navigation =====
  listen(document, 'keydown', function(e) {
    const isSearchOpen = searchOverlay && searchOverlay.classList.contains('is-open');
    const isDrawerOpen = drawer && drawer.classList.contains('is-open');
    const isTyping = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName) ||
                     document.activeElement?.isContentEditable;

    // Escape closes everything
    if (e.key === 'Escape') {
      if (isSearchOpen || isDrawerOpen) e.preventDefault();
      closeDrawer();
      closeSearch();
      menuItems.forEach(item => {
        if (item.classList.contains('is-open') && item.contains(document.activeElement)) item.querySelector('.mc-menu-link')?.focus();
        item.classList.remove('is-open');
        const link = item.querySelector('.mc-menu-link');
        link && link.setAttribute('aria-expanded', 'false');
      });
    }

    // "/" or Cmd/Ctrl+K opens search (when not typing in an input)
    if (!isTyping && !isSearchOpen && !isDrawerOpen) {
      if (e.key === '/') {
        e.preventDefault();
        if (searchBehavior === 'live' && searchOverlay) {
          openSearch();
        } else if (searchBehavior === 'theme') {
          document.dispatchEvent(new CustomEvent('dispatch:search:open'));
        }
      }
    }

    // Cmd/Ctrl+K also opens search even when typing (common pattern)
    if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      if (!isSearchOpen) {
        if (searchBehavior === 'live' && searchOverlay) {
          openSearch();
        } else if (searchBehavior === 'theme') {
          document.dispatchEvent(new CustomEvent('dispatch:search:open'));
        }
      }
    }

    if (e.key === 'Tab' && isSearchOpen) trapFocus(e, searchOverlay);
    if (e.key === 'Tab' && isDrawerOpen && !isSearchOpen) trapFocus(e, drawer);
  });
  
  function focusDropdownAfterPaint(item, trigger) {
    let attempts = 0;
    function tryFocus() {
      if (disposed || !item.isConnected || !item.classList.contains('is-open') || document.activeElement !== trigger) return;
      const panel = item.querySelector('.mc-menu-dropdown');
      const first = panel && visibleFocusable(panel)[0];
      first?.focus();
      if (document.activeElement === first) return;
      attempts += 1;
      if (attempts < 6) setTimeout(() => requestAnimationFrame(tryFocus), 50);
    }
    requestAnimationFrame(() => requestAnimationFrame(tryFocus));
  }

  // Arrow key navigation for menu items
  menuItems.forEach((item, idx) => {
    const link = item.querySelector('.mc-menu-link');
    if (!link) return;
    
    listen(link, 'keydown', function(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const next = menuItems[idx + 1];
        next && next.querySelector('.mc-menu-link')?.focus();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        const prev = menuItems[idx - 1];
        prev && prev.querySelector('.mc-menu-link')?.focus();
      } else if (['ArrowDown', 'Enter', ' '].includes(e.key) && item.classList.contains('has-dropdown')) {
        e.preventDefault();
        menuItems.forEach((other) => {
          if (other === item) return;
          other.classList.remove('is-open');
          other.querySelector('.mc-menu-link')?.setAttribute('aria-expanded', 'false');
        });
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
        focusDropdownAfterPaint(item, link);
      }
    });
  });
  
  let mobileLayout = Boolean(toggle?.getClientRects().length);
  listen(window, 'resize', debounce(() => {
    const nextMobile = Boolean(toggle?.getClientRects().length);
    if (nextMobile === mobileLayout) return;
    mobileLayout = nextMobile;
    closeDrawer(); closeSearch();
    menuItems.forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('.mc-menu-link')?.setAttribute('aria-expanded', 'false');
    });
  }, 100));

  // ===== Top Bar (Combined Announcement + Secondary) =====
  const topbar = $('[data-mc-topbar]');
  const topbarClose = $('[data-mc-topbar-close]');
  const announcementSlider = $('[data-mc-announcement-slider]');
  
  if (topbar) {
    // Check if dismissed
    if (sessionStorage.getItem('mc-topbar-dismissed') === 'true') {
      topbar.style.display = 'none';
    }
    
    if (topbarClose) {
      listen(topbarClose, 'click', function() {
        topbar.style.display = 'none';
        sessionStorage.setItem('mc-topbar-dismissed', 'true');
      });
    }
    
    // Rotating announcements with arrow navigation
    if (announcementSlider) {
      const slides = announcementSlider.querySelectorAll('.mc-menu-topbar-slide');
      const prevBtn = $('[data-mc-announcement-prev]');
      const nextBtn = $('[data-mc-announcement-next]');
      let currentSlide = 0;
      let autoplayTimer = null;
      
      function goToSlide(index, direction) {
        if (slides.length <= 1) return;
        
        slides[currentSlide].classList.remove('is-active');
        slides[currentSlide].classList.add('is-leaving');
        
        currentSlide = ((index % slides.length) + slides.length) % slides.length;
        slides[currentSlide].classList.add('is-active');
        
        setTimeout(function() {
          slides.forEach(s => s.classList.remove('is-leaving'));
        }, 400);
      }
      
      function nextSlide() {
        goToSlide(currentSlide + 1, 'next');
      }
      
      function prevSlide() {
        goToSlide(currentSlide - 1, 'prev');
      }
      
      function startAutoplay() {
        if (autoplayTimer) clearInterval(autoplayTimer);
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || announcementSlider.contains(document.activeElement) || announcementSlider.matches(':hover')) return;
        autoplayTimer = setInterval(nextSlide, Math.max(5000, Number(wrapper.dataset.announcementInterval || 6000)));
      }
      
      function resetAutoplay() {
        startAutoplay();
      }
      
      if (slides.length > 1) {
        const stopAutoplay = () => { clearInterval(autoplayTimer); autoplayTimer = null; };
        listen(announcementSlider, 'mouseenter', stopAutoplay);
        listen(announcementSlider, 'focusin', stopAutoplay);
        listen(announcementSlider, 'mouseleave', startAutoplay);
        listen(announcementSlider, 'focusout', () => setTimeout(startAutoplay, 0));
        slides[0].classList.add('is-active');
        startAutoplay();
        
        // Arrow navigation
        if (prevBtn) {
          listen(prevBtn, 'click', function(e) {
            e.preventDefault();
            prevSlide();
            resetAutoplay();
          });
        }
        
        if (nextBtn) {
          listen(nextBtn, 'click', function(e) {
            e.preventDefault();
            nextSlide();
            resetAutoplay();
          });
        }
      } else if (slides.length === 1) {
        slides[0].classList.add('is-active');
      }
    }
    
  }


  // ===== Countdown Timer =====
  const countdownElements = $$('[data-mc-countdown]');

  countdownElements.forEach(function(countdown) {
    const endDateStr = countdown.dataset.endDate;
    const expiredMessage = countdown.dataset.expiredMessage || 'Sale has ended';
    const hideExpired = countdown.dataset.hideExpired === 'true';

    if (!endDateStr) return;

    // Parse the date string (format: YYYY-MM-DD HH:MM)
    const endDate = new Date(endDateStr.replace(' ', 'T'));

    if (isNaN(endDate.getTime())) {
      console.warn('MC Menu: Invalid countdown date format:', endDateStr);
      return;
    }

    const daysEl = countdown.querySelector('[data-countdown-days]');
    const hoursEl = countdown.querySelector('[data-countdown-hours]');
    const minutesEl = countdown.querySelector('[data-countdown-minutes]');
    const secondsEl = countdown.querySelector('[data-countdown-seconds]');
    const messageEl = countdown.querySelector('.mc-menu-countdown-message');
    const countdownEl = countdown.querySelector('.mc-menu-countdown');

    function updateCountdown() {
      const now = new Date().getTime();
      const distance = endDate.getTime() - now;

      if (distance < 0) {
        // Countdown has ended
        countdown.classList.add('is-expired');

        if (hideExpired) {
          countdown.classList.add('is-hidden');
        } else if (messageEl && countdownEl) {
          messageEl.textContent = expiredMessage;
          countdownEl.style.display = 'none';
        }
        return false; // Stop the interval
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');

      return true; // Continue the interval
    }

    // Initial update
    if (updateCountdown()) {
      // Update every second
      const intervalId = setInterval(function() {
        if (!updateCountdown()) {
          clearInterval(intervalId);
        }
      }, 1000);
    }
  });


  // ===== Localization Selectors =====
  const localizationBtns = $$('[data-mc-localization]');
  
  localizationBtns.forEach(function(btn) {
    const list = btn.nextElementSibling;
    if (!list) return;
    
    listen(btn, 'click', function(e) {
      e.stopPropagation();
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      
      // Close other localization dropdowns
      localizationBtns.forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        const l = b.nextElementSibling;
        if (l) l.hidden = true;
      });
      
      btn.setAttribute('aria-expanded', String(!isOpen));
      list.hidden = isOpen;
    });
  });
  
  // Close localization on outside click
  listen(document, 'click', function(e) {
    localizationBtns.forEach(function(btn) {
      if (!btn.closest('.mc-menu-localization').contains(e.target)) {
        btn.setAttribute('aria-expanded', 'false');
        const list = btn.nextElementSibling;
        if (list) list.hidden = true;
      }
    });
  });

  // ===== Mobile Localization (Currency/Language) Selectors =====
  // Handle dropdown select change - auto-submit form
  const mobileCountrySelect = $('[data-mc-mobile-country]');
  const mobileLanguageSelect = $('[data-mc-mobile-language]');

  if (mobileCountrySelect) {
    listen(mobileCountrySelect, 'change', function() {
      const form = this.closest('form');
      if (form) form.submit();
    });
  }

  if (mobileLanguageSelect) {
    listen(mobileLanguageSelect, 'change', function() {
      const form = this.closest('form');
      if (form) form.submit();
    });
  }

  }
  function mount(root) {
    for (const [wrapper, dispose] of instances) if (!wrapper.isConnected) dispose();
    if (root.matches?.("[data-mc-menu]")) initialize(root);
    root.querySelectorAll("[data-mc-menu]").forEach(initialize);
  }
  window.mcMenuRuntime = { mount };
  document.addEventListener("shopify:section:load", (event) => mount(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    for (const [wrapper, dispose] of instances) if (event.target.contains(wrapper)) dispose();
  });
  mount(document);
})();
